// extracted by mini-css-extract-plugin
export var actions = "_gx-d";
export var benefitCard = "_gx-a";
export var benefitIcon = "_gx-b";
export var benefitLabel = "_gx-c";
export var benefits = "_gx-9";
export var bodyText = "_gx-8";
export var closeButton = "_gx-2";
export var content = "_gx-3";
export var eyebrow = "_gx-4";
export var heading = "_gx-5";
export var image = "_gx-f";
export var imagePanel = "_gx-e";
export var modal = "_gx-0";
export var shell = "_gx-1";
export var title = "_gx-6";
export var titleOffer = "_gx-7";